exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main